import {
  ProjectManagementProjectDetailsPageSettingsBudgetSectionUpdateCostPlanningDocument,
  ProjectManagementProjectDetailsPageSettingsBudgetSectionUpdateCostPlanningMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

interface updateFixedCostPlanningDto {
  fixedCostPlanningId: number
  budgetAllocationCents: number
  feeAmountCents?: number
}

export const useUpdateFixedCostPlanning = () => {
  const [updateFixedCostPlanning] = useMutation(
    ProjectManagementProjectDetailsPageSettingsBudgetSectionUpdateCostPlanningDocument,
    {
      extractorFn: (
        data: ProjectManagementProjectDetailsPageSettingsBudgetSectionUpdateCostPlanningMutation
      ) => data.projectManagementMutations.updateProjectmanagementFixedCostPlanning,
    }
  )

  return {
    update(dto: updateFixedCostPlanningDto) {
      const { fixedCostPlanningId, budgetAllocationCents, feeAmountCents } = dto
      return updateFixedCostPlanning({
        variables: {
          id: fixedCostPlanningId,
          budgetAllocationCents: budgetAllocationCents,
          feeAmountCents: feeAmountCents,
        },
        optimisticResponse: {
          projectManagementMutations: {
            updateProjectmanagementFixedCostPlanning: {
              errors: [],
              fixedCostPlanning: {
                __typename: 'ProjectManagementFixedCostPlanning',
                id: fixedCostPlanningId,
                budgetAllocationCents: budgetAllocationCents,
                feeAmountCents: feeAmountCents ? feeAmountCents : undefined,
              },
            },
          },
        },
      })
    },
  }
}
